export class AccountGroup {
    id: number;
    nameGroup: string;
}
